const payRemainingBalanceReducer = (state = 0, action) => {
	switch(action.type){
	case 'PAYREMAINBAL':
		return action.payload;
	default:
		return state;
	}
}

export default payRemainingBalanceReducer;